'use client'

import { useSession } from 'next-auth/react'
import { useTranslations } from 'next-intl'

import { FileDownloadButton } from '@/components/file-download-button'

export default function HeaderTopbarMenu() {
  const { data: session } = useSession()
  const t = useTranslations('commerce-blocks')

  if (!session?.user?.company) {
    return null
  }

  return (
    <FileDownloadButton
      className="header-topbar-menu__download"
      url="/api/customer/price-list"
      fallbackFileName="price-list.xlsx"
    >
      {t('header-topbar.download-price-list')}
    </FileDownloadButton>
  )
}
